import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

interface AddNoteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onNoteAdd: (content: string, noteType: 'general' | 'follow_up' | 'important') => void;
  isAdding: boolean;
}

export const AddNoteModal = ({ 
  open, 
  onOpenChange, 
  onNoteAdd, 
  isAdding 
}: AddNoteModalProps) => {
  const [content, setContent] = useState('');
  const [noteType, setNoteType] = useState<'general' | 'follow_up' | 'important'>('general');

  const handleSubmit = () => {
    if (content.trim()) {
      onNoteAdd(content.trim(), noteType);
      // Reset form
      setContent('');
      setNoteType('general');
      onOpenChange(false);
    }
  };

  const resetForm = () => {
    setContent('');
    setNoteType('general');
  };

  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);

  const noteTypes = [
    { value: 'general', label: 'Genel Not' },
    { value: 'follow_up', label: 'Takip Notu' },
    { value: 'important', label: 'Önemli Not' },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Ziyarete Not Ekle</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Note Type */}
          <div className="space-y-2">
            <Label>Not Türü</Label>
            <Select value={noteType} onValueChange={(value: 'general' | 'follow_up' | 'important') => setNoteType(value)}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {noteTypes.map((type) => (
                  <SelectItem key={type.value} value={type.value}>
                    {type.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {/* Note Content */}
          <div className="space-y-2">
            <Label>Not İçeriği</Label>
            <Textarea
              placeholder="Ziyaret notu yazın..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={5}
              className="resize-none"
            />
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
              İptal
            </Button>
            <Button 
              onClick={handleSubmit} 
              disabled={!content.trim() || isAdding}
              className="flex-1"
            >
              {isAdding ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Ekleniyor...
                </>
              ) : (
                'Not Ekle'
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
